<template>
  <v-navigation-drawer
    fixed
    width="350"
    right
    permanent
    transition="scale-transition"
    class="side-bar-filters"
  >
    <v-layout row>
      <v-flex lg12>
        <v-layout row>
          <v-flex d-flex align-center class="text-xs-left py-0">
            <div class="flex-grow-0">
              <v-icon @click="closeFilters()">close</v-icon>
            </div>
            <h3>{{ translation('filters.btn-filter') }}</h3>
          </v-flex>
          <v-flex class="text-xs-right py-0 px-0">
            <v-btn color="default" depressed @click.stop="clearFilters()">
              {{ translation('filters.btn-clear.filters') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-divider class="mt-2"></v-divider>
        <!-- filters group wrapper -->
        <v-layout row wrap>
          <!-- save filters section -->
          <v-flex xs12 d-flex class="py-0">
            <v-expansion-panel class="elevation-0" :value="opened">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h3 class="panel--header">{{ translation('filter.group.name.save-filter') }}</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 d-flex>
                        <filter-save
                          v-if="renderFilters"
                          :current-filter="selectedFiltersGen"
                          @set-filters="setFilters">
                        </filter-save>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <!-- filters group -->
          <v-flex xs12 d-flex class="py-0">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h3 class="panel--header">{{ translation('filter.group.name.handler') }}</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "dealer_name"
                          filter-key = "filterDealer"
                          filter-name = "filter.name.dealer"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <!-- filters group -->
          <v-flex xs12 d-flex class="py-0">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h3 class="panel--header">{{ translation('filter.group.name.car') }}</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "brand_name"
                          filter-key = "filterBrand"
                          filter-name = "filter.name.brand"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                      <v-flex xs12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "model_name"
                          filter-key = "filterModel"
                          filter-name = "filter.name.model"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                      <v-flex xs12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "condition"
                          filter-key = "filterCondition"
                          filter-name = "filter.name.condition"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                      <v-flex xs12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "vehicle_status"
                          filter-key = "filterVehicleStatus"
                          filter-name = "filter.name.vehicle-status"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                      <v-flex xs12 d-flex>
                          <filter-select
                            v-if="renderFilters"
                            filter-id = "commission_type"
                            filter-key = "filterCommissionType"
                            filter-name = "filter.name.commission-type"
                            @update-filters="updateFilters">
                          </filter-select>
                        </v-flex>
                        <v-flex xs12 d-flex>
                          <filter-select
                            v-if="renderFilters"
                            filter-id = "status_sale"
                            filter-key = "filterStatusSale"
                            filter-name = "filter.name.status-sale"
                            @update-filters="updateFilters">
                          </filter-select>
                        </v-flex>
                        <v-flex xs12 d-flex>
                          <filter-select
                            v-if="renderFilters"
                            filter-id = "status_purchase"
                            filter-key = "filterStatusPurchase"
                            filter-name = "filter.name.status-purchase"
                            @update-filters="updateFilters">
                          </filter-select>
                        </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <v-layout row>
            <v-flex class="py-3">
              <v-btn color="accent" depressed @click.stop="applyFilters()">
                {{ translation('filters.btn-apply.filters') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
// import moment from 'moment'
// import _ from 'underscore'
// import filter components
import FilterSelect from '@/components/filters/FilterSelectNew'
// import FilterDateTime from '@/components/filters/FilterDateTimeNewGen'
import FilterSave from '../../filters/FilterSave.vue'

let initFilters = [
  {
    outputId: 'dealer_name',
    queryKey: 'filterDealer',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 10000
    }
  },
  {
    outputId: 'brand_name',
    queryKey: 'filterBrand',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 10000
    }
  },
  {
    outputId: 'model_name',
    queryKey: 'filterModel',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 10000
    }
  },
  {
    outputId: 'condition',
    queryKey: 'filterCondition',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 10000
    }
  },
  {
    outputId: 'vehicle_status',
    queryKey: 'filterVehicleStatus',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 10000
    }
  },
  {
    outputId: 'status_sale',
    queryKey: 'filterStatusSale',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 10000
    }
  },
  {
    outputId: 'status_purchase',
    queryKey: 'filterStatusPurchase',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 10000
    }
  },
  {
    outputId: 'commission_type',
    queryKey: 'filterCommissionType',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 10000
    }
  }
]

export default {
  name: 'DashboardSidebarFilters',
  components: {
    FilterSelect,
    // FilterDateTime,
    FilterSave
  },
  props: {
    dashboardId: { type: String, required: true }
  },
  data () {
    return {
      renderFilters: false,
      extendFilters: false,
      opened: 0
    }
  },
  computed: {
    ...mapGetters(['selectedFiltersGen', 'translation', 'filterItemGen'])
  },
  created () {
    // set dashboard data with received props
    this.setGeneric(true)
    // assign timePeriodsExtend from config
    this.$log.info(`-${this.dashboardId} dashboard filters component created-`)
    this.$log.info('Initializing filters', initFilters)
    this.setInitialSelectedFilters(initFilters)
    this.resetFilters()
    // fetch filters data
    // TODO - set auto updateFilters if timePeriod not set
    this.updateFilters() // enable if no default timePeriod set
    this.renderFilters = true
  },
  methods: {
    ...mapMutations({
      setInitialSelectedFilters: 'GEN_SET_INITIAL_SELECTED_FILTERS',
      // disabled filters mutations
      setItemStatus: 'GEN_SET_ITEM_FILTER_STATUS',
      // set dashboard as generic
      setGeneric: 'GEN_SET_GENERIC',
      // set time periods
      setTimePeriods: 'GEN_SET_TIMEPERIODS'
    }),
    ...mapActions([
      // fetch filters actions
      'fetchDataGen',
      'fetchAnyTimeGen',
      'setActiveFilter'
    ]),
    updateFilters (preference) {
      if (!preference) {
        this.setActiveFilter({ name: '', value: null })
      }
      const requestPayloadData = {
        filters: preference || this.selectedFiltersGen,
        dashboardId: this.dashboardId
      }
      // fetch filters
      initFilters.forEach(val => {
        if (val.queryKey) {
          if (val.type === 'time') {
            this.fetchAnyTimeGen({ selected: requestPayloadData, filterId: val.outputId, filterKey: val.queryKey })
          } else {
            this.fetchDataGen({ selected: requestPayloadData, filterId: val.outputId, filterKey: val.queryKey, pagination: val.pagination })
          }
        }
      })
    },
    applyFilters () {
      this.$emit('apply-filters')
    },
    resetFilters () {
      this.$store.commit('GEN_RESET_FILTERS', initFilters)
    },
    clearFilters () {
      // reset filters to init state
      this.resetFilters()
      // reset active saved filter
      this.setActiveFilter({ name: '', value: null })
      // set disabled states to false
      initFilters.forEach(val => {
        this.setItemStatus(val.outputId, true)
      })
      this.updateFilters()
      // emit event for fetching data with selected filters
      this.$emit('clear-filters')
    },
    closeFilters () {
      this.$emit('close-filters')
    },
    timePeriodsTranslated (periods) {
      let translatedTimePeriods = periods.map(timePeriod => {
        timePeriod.name = this.translation(timePeriod.name)
        return timePeriod
      })
      return translatedTimePeriods
    },
    setFilters (preference) {
      initFilters.forEach(val => {
        if (val.outputId && preference.hasOwnProperty(val.outputId)) {
          this.$store.commit('GEN_SET_SELECTED_FILTER_ITEM', { key: val.outputId, value: preference[val.outputId] })
        }
      })
      this.updateFilters(preference)
    }
  },
  destroyed () {
    this.extendFilters = false
    this.$log.info(`-${this.dashboardId} filters before destroyed-`)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.side-bar-filters {
  padding: 25px 15px;
  .v-btn {
    border-radius: 4px;
    text-transform: none;
    min-width: 100px;
  }
  .v-expansion-panel {
    .v-expansion-panel__container {
      border-bottom: 1px solid rgba(0, 0, 0, .2);
      &:hover {
        border-bottom: 1px solid rgba(0, 0 , 0 , .3);
      }
      &.v-expansion-panel__container--active {
        border-bottom: 1px solid #009aff;
        .v-expansion-panel__header {
          color: #009aff;
          &:hover {
            background-color: transparent;
          }
        }
      }
      .v-expansion-panel__header {
        padding: 10px 0 !important;
        &:hover {
          background-color: rgba(0, 0 , 0 , .04);
        }
      }
    }
  }
  .v-card {
    box-shadow: none;
    .v-card__text {
      padding: 16px 0;
    }
  }
}
</style>
